import { HTMLAttributes } from 'react';
import { cn } from '@lib/utils/cn';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'primary' | 'success' | 'warning' | 'danger' | 'info';
  size?: 'sm' | 'md' | 'lg';
}

const variants = {
  default: 'bg-secondary-100 text-secondary-800 dark:bg-secondary-700 dark:text-secondary-100',
  primary: 'bg-primary-100 text-primary-800 dark:bg-primary-900 dark:text-primary-100',
  success: 'bg-success-100 text-success-800 dark:bg-success-900 dark:text-success-100',
  warning: 'bg-warning-100 text-warning-800 dark:bg-warning-900 dark:text-warning-100',
  danger: 'bg-danger-100 text-danger-800 dark:bg-danger-900 dark:text-danger-100',
  info: 'bg-primary-100 text-primary-800 dark:bg-primary-900 dark:text-primary-100',
};

const sizes = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-sm',
  lg: 'px-3 py-1.5 text-base',
};

export function Badge({
  variant = 'default',
  size = 'md',
  className,
  children,
  ...props
}: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full font-medium',
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}
